
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHardHat } from "@fortawesome/free-solid-svg-icons";
import { faClipboardList } from "@fortawesome/free-solid-svg-icons";
import { Badge, Icon } from "@material-ui/core";
import BatteryIcon from "@material-ui/icons/Battery80";

export const LOAD_AUTHORIZED_APPS = 'LOAD_AUTHORIZED_APPS';
export const ADD_AUTHORIZED_APP = 'ADD_AUTHORIZED_APP';
export const UPDATE_AUTHORIZED_APP = 'UPDATE_AUTHORIZED_APP';
export const DELETE_AUTHORIZED_APP = 'DELETE_AUTHORIZED_APP';

export const MODULE_SAISIE_TEMPS = "SAISIE_TEMPS";
export const MODULE_FLUIDES = "FLUIDES";
export const MODULE_ABSENCES = "ABSENCES";
export const MODULE_COMPONENTS_PARK = "COMPONENTS_PARK";
export const MODULE_INTERVENTIONS = "INTERVENTIONS";
export const MODULE_ANALYSE_RISQUES = "ANALYSE_RISQUES";
export const MODULE_PPS = "PPS";
export const MODULE_SUIVI_CHANTIER = "SUIVI_CHANTIER";
export const MODULE_HUMAN_RESOURCES = "HUMAN_RESOURCES";
export const MODULE_DRH = "DRH";

export const MODULE_EXTRANET_INTERVENTIONS = "MODULE_EXTRANET_INTERVENTIONS";
export const MODULE_EXTRANET_CONTRACTS_AND_AFFAIRS = "MODULE_EXTRANET_CONTRACTS_AND_AFFAIRS";
export const MODULE_EXTRANET_COMPONENTS_PARK = "MODULE_EXTRANET_COMPONENTS_PARK";
export const MODULE_EXTRANET_DOCUMENTATIONS = "MODULE_EXTRANET_DOCUMENTATIONS";
export const MODULE_EXTRANET_INDICATORS = "MODULE_EXTRANET_INDICATORS";
export const MODULE_EXTRANET_QUOTES = "MODULE_EXTRANET_QUOTES";
export const MODULE_EXTRANET_INVOICES = "MODULE_EXTRANET_INVOICES";

export const MODULE_CONTACT_US = "MODULE_CONTACT_US";

export const faIconStyle = {
    color: "#F5F6F5",
    "&:hover": {
        color: "#001A70",
    },
    width: "32px",
    height: "32px",
    margin: "auto",
};

export const materialUIIconStyle = {
    display: "block",
    width: "35px",
    height: "35px",
    color: "#F5F6F5",
    margin: "auto",
    fontSize: "35px"
}

export const ALL_APPS = [
    {
        code: MODULE_SAISIE_TEMPS,
        name: "Saisie des temps",
        url: '/activity',
        icon: (<Icon color="secondary" style={materialUIIconStyle}>history</Icon>),
    },
    {
        code: MODULE_FLUIDES,
        name: "Fluides",
        url: '/fluide',
        icon: (<BatteryIcon color="secondary" style={materialUIIconStyle} />),
    },
    {
        code: MODULE_ABSENCES,
        name: "Absences",
        url: '/absences',
        icon: (<Icon color="secondary" style={materialUIIconStyle}>event_busy</Icon>),
    },
    {
        code: MODULE_COMPONENTS_PARK,
        name: "Parc machines",
        url: '/componentsPark',
    },
    {
        code: MODULE_INTERVENTIONS,
        name: "Interventions",
        url: '/interventions',
        icon: (<FontAwesomeIcon icon={faClipboardList} className={"fa-2x"} style={faIconStyle} alt="Interventions" />),
    },
    {
        code: MODULE_ANALYSE_RISQUES,
        name: "Analyses de risques",
        url: '/analyseRisques',
        icon: (<Icon color="secondary" style={materialUIIconStyle}>error_outline</Icon>),
    },
    {
        code: MODULE_PPS,
        name: "Plan de prévention simplifié",
        url: '/pps',
        icon: (<Icon color="secondary" style={materialUIIconStyle}>verified_user</Icon>),
    },
    {
        code: MODULE_SUIVI_CHANTIER,
        name: "Suivi de chantier",
        url: '/siteMonitorings',
        icon: (<FontAwesomeIcon icon={faHardHat} className={"fa-2x"} alt="siteMonitorings" style={faIconStyle} />),
    },
    {
        code: MODULE_EXTRANET_INTERVENTIONS,
        name: "Interventions",
        url: "/interventions",
        icon: (<FontAwesomeIcon icon={faClipboardList} className={"fa-2x"} style={faIconStyle} alt="Interventions" />),
    },
    {
        code: MODULE_CONTACT_US,
        name: "Nous contacter",
        url: "/contactUs",
        icon: (<Icon color="secondary" style={materialUIIconStyle}>contact_support</Icon>),
    },
    {
        code: MODULE_EXTRANET_CONTRACTS_AND_AFFAIRS,
        name: "Contrats et affaires",
        url: "/affairs",
        icon: (<Icon color="secondary" style={materialUIIconStyle}>folder</Icon>),
    },
    {
        code: MODULE_EXTRANET_COMPONENTS_PARK,
        name: "Parc",
        url: "/parks",
        icon: (
            <Badge style={materialUIIconStyle} badgeContent={<Icon style={{ fontSize: "20px", color: "#F5F6F5" }}>ac_unit</Icon>} anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}>
                <Icon color="secondary" style={{
                    ...materialUIIconStyle,
                    fontSize: "32px",
                }}>settings</Icon>
            </Badge>
        ),
    },
    // {
    //     code: MODULE_EXTRANET_DOCUMENTATIONS,
    //     name: "Documents",
    //     url: "/documentations",
    //     icon: (<Icon color="secondary" style={materialUIIconStyle}>menu_book</Icon>),
    // },
    // {
    //     code: MODULE_EXTRANET_INDICATORS,
    //     name: "Indicateurs",
    //     url: "/indicators",
    //     icon: (<Icon color="secondary" style={materialUIIconStyle}>bar_chart</Icon>),
    // },
    {
        code: MODULE_EXTRANET_QUOTES,
        name: "Devis",
        url: "/quotes",
        icon: (<Icon color="secondary" style={materialUIIconStyle}>note_add</Icon>),
    },
    {
        code: MODULE_EXTRANET_INVOICES,
        name: "Factures",
        url: "/invoices",
        icon: (<Icon color="secondary" style={materialUIIconStyle}>description</Icon>),
    },
]
